import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';

import { DynamicDocs } from './components/DynamicDocs';

export const techdocsModuleIpen = createFrontendModule({
  extensions: [
    techdocsPlugin.getExtension('page:techdocs/reader').override({
      params: {
        loader: async () =>
          import('./components/MkDocsPage').then(m => <m.MkDocsPage />),
      },
    }),
    PageBlueprint.make({
      name: 'MkDocs',
      params: {
        loader: async () =>
          import('./components/MkDocsPage').then(m => <m.MkDocsPage />),
        noHeader: true,
        path: '/docs/:namespace/:kind/:name/*',
      },
    }),
    techdocsPlugin.getExtension('entity-content:techdocs').override({
      disabled: true,
      params: {
        loader: async () =>
          import('./components/MkDocsPage').then(m => <m.MkDocsPage />),
        path: '/docs/:namespace/:kind/:name/*',
      },
    }),

    DynamicDocs,
  ],
  featureFlags: [{ name: 'show-mkdocs-header' }],
  pluginId: 'techdocs',
});
